/**
 * Topics de createEventMark (GraphQL) para avisos al check-in abierto en la PWA.
 * Contrato: entity === "checkin", entityId === id (UUID) del check-in — no usar el nombre del topic como entityId.
 * @see CheckInContext — suscripción onCreateEventMark y refreshStatus al subir eventVersion.
 */

export const CHECKIN_EVENT_TOPIC_REASSIGNED_ROOM = 'reassigned-room';

/** Temas que en pantallas de acceso deben forzar caché de smartlocks + cuenta */
export const CHECKIN_EVENT_TOPICS_REFRESH_ACCESS = new Set([
  CHECKIN_EVENT_TOPIC_REASSIGNED_ROOM,
]);
